// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { TIME_ENTRY_MODAL_CLOSED_EVENT } from '@/features/TimeEntry/constants';
import { type Task, type TimeEntry } from '@/generated/graphql';

type StartTimeTrackerPayload = {
	taskId: Task['id'];
	completePreviousTracker?: {
		timeEntryId: TimeEntry['id'];
		openModalOnly: boolean;
	};
};

type CompleteActiveTimeTrackerPayload = {
	timeEntryId: TimeEntry['id'];
	openModalOnly: boolean;
};

type ModifyTimeEntryPayload = {
	taskId: Task['id'];
	duration: number;
	isCompleted: boolean;
	timeEntryId?: TimeEntry['id'];
};

const onStartTimeTracker = (payload: StartTimeTrackerPayload) => {
	const startData = {
		startTimeTracker: true,
		task_id: payload.taskId,
	};

	const runStartTimeTracker = () => {
		scoro.submitAjax(
			'_components/timeTracker/timeTracker/regularAjax',
			() => {},
			startData
		);
	};

	const previous = payload.completePreviousTracker;
	if (!previous?.timeEntryId) {
		runStartTimeTracker();

		return;
	}

	if (previous.openModalOnly) {
		const onModalClosed = () => {
			removeEventListener(TIME_ENTRY_MODAL_CLOSED_EVENT, onModalClosed);
			runStartTimeTracker();
		};

		addEventListener(TIME_ENTRY_MODAL_CLOSED_EVENT, onModalClosed, {
			once: true,
		});

		popModal('timeEntry', {
			timeEntryId: previous.timeEntryId,
			validateOnLoad: true,
			is_completed: 1,
		});

		return;
	}

	scoro.submitAjax(
		'_components/timeTracker/timeTracker/regularAjax',
		(params, response) => {
			if (response?.status === 'OK' && !response?.messages?.error) {
				runStartTimeTracker();
			} else if (response?.messages?.error?.length > 0) {
				scoro.showFloatingErrorMessage(response.messages.error[0]);
			}
		},
		{
			logTimeTracker: true,
			time_entry_id: previous.timeEntryId,
			event_type: 'stopped-tracking-event',
		}
	);
};

const onCompleteActiveTimeTracker = (
	payload: CompleteActiveTimeTrackerPayload
) => {
	if (payload.openModalOnly) {
		popModal('timeEntry', {
			timeEntryId: payload.timeEntryId,
			validateOnLoad: true,
			is_completed: 1,
		});

		return;
	}

	scoro.submitAjax(
		'_components/timeTracker/timeTracker/regularAjax',
		() => {},
		{
			logTimeTracker: true,
			time_entry_id: payload.timeEntryId,
			event_type: 'stopped-tracking-event',
		}
	);
};

const onModifyTimeEntry = (payload: ModifyTimeEntryPayload) => {
	if (payload.timeEntryId) {
		popModal('timeEntry', {
			timeEntryId: payload.timeEntryId,
			is_completed: payload.isCompleted ? 1 : 0,
		});

		return;
	}

	const args = {
		event_id: payload.taskId,
		is_completed: payload.isCompleted ? 1 : 0,
	};

	if (payload.duration > 0) {
		args.duration = payload.duration;
	}

	popModal('timeEntry', args);
};

export const timeTrackerMonolithHandlers = {
	onStartTimeTracker,
	onCompleteActiveTimeTracker,
	onModifyTimeEntry,
};
